<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	//Design system components
	import { Button, Text, Slider } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device;

	const id: string = device.id,
		settings: { [key: string]: any } = readDeviceSettings(id);

	let reportHoldoff: number = settings?.['flood:0']?.report_holdoff || 0;
	let cacheValue: number = reportHoldoff;
	let waitForResponse: boolean = false;

	const save = async () => {
		try {
			if (cacheValue === reportHoldoff) return;
			waitForResponse = true;
			const res: SettingRequest = await gen2Request(
				device,
				'Flood.SetConfig',
				{
					id: device.channel,
					config: {
						report_holdoff: reportHoldoff,
					},
				},
				true,
			);
			const response: SettingRequest = await onSettingsResponse(res, device);
			if (response.isok) {
				settings['flood:0'].report_holdoff = reportHoldoff;
				devices_settings.update_devices_settings(id, settings);
				cacheValue = reportHoldoff;
			} else {
				reportHoldoff = settings?.['flood:0']?.report_holdoff || 0;
				reportHoldoff = cacheValue;
				throw new Error('Settings not saved');
			}
			waitForResponse = false;
		} catch (error) {
			waitForResponse = false;
			console.error(error);
		}
	};

	const a11yProps = {
		sliderValueText: $format('current_report_holdoff_value', {
			values: { value: reportHoldoff },
			default: `Current report holdoff value is ${reportHoldoff} seconds`,
		}),
		ariaLabel: $format('label_set_report_holdoff', { default: 'Set Report Holdoff' }),
		ariaLabelValue: $format('current_report_holdoff_value', {
			values: { value: reportHoldoff },
			default: `Current report holdoff value is ${reportHoldoff} seconds`,
		}),
	};
</script>

<Text styleType="body" class="mb-l"
	>{$format('state_hold_time_description', {
		default: 'Reports a flood state change only if the same state is held for the defined period.',
	})}</Text
>
<Slider
	id="slider-o20fmu0"
	{a11yProps}
	class="mb-l"
	title={capFirstChar($format('label_report_holdoff', { default: 'Report hold off' }))}
	isLoading={waitForResponse}
	bind:value={reportHoldoff}
	type="incremented"
	min={0}
	max={60}
	step={5}
	unit="s"
/>

<Button loading={waitForResponse} size="m" width="full" on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
